import { render } from "./ForgotPasswordRequested.vue?vue&type=template&id=7816e001"
const script = {}

import "./ForgotPasswordRequested.vue?vue&type=style&index=0&id=7816e001&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__